import { render, staticRenderFns } from "./AdditionalDvr.vue?vue&type=template&id=0ddace5c&scoped=true&"
import script from "./AdditionalDvr.vue?vue&type=script&lang=ts&"
export * from "./AdditionalDvr.vue?vue&type=script&lang=ts&"
import style0 from "./AdditionalDvr.vue?vue&type=style&index=0&id=0ddace5c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ddace5c",
  null
  
)

export default component.exports